export default "__VITE_ASSET__D87Pjt_V__"